// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

.cardBox {
  background-color: #1e293b;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  transition: 0.3s ease-in-out;
}

.cardBox:hover {
  transform: scale(1.03);
}

.cardtopic {
  text-align: center;
  margin-bottom: 16px;
}

.cardtopic h3 {
  color: #ffffff;
  font-size: 18px;
}

.circle {
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
}

.cards .circle {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 15px;
}
.cards .circle h1 {
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
}
.cards .title {
  text-align: right;
}
.cards .circle p {
  color: #ffffff;
  margin-top: 10px;
  font-size: 17px;
}
.light .circle h1,
.light .circle p {
  color: #ffffff;
}

.Phasetitle {
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
}
.card.grid {
  color: white;
}
g.tick text {
  fill: #ffffff !important; /* White tick labels */
  font-size: 15px !important;
  font-family: 'Arial', sans-serif;
}
.dark g.tick text {
  fill: #ffffff !important;
}

.cardHeading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.cardHeading h3 {
  color: #ffffff;   /* Phase 1 / Phase 2 / Phase 3 */
  font-size: 18px;
  font-weight: 600;
}

.cardHeading .headingIcon {
  color: #ffffff;   /* three-dot icon */
}


.light g.tick text {
  fill: #111827 !important; /* dark gray for light mode */
}
`, "",{"version":3,"sources":["webpack://./src/components/cards/cards.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,wBAAwB,EAAE,sBAAsB;EAChD,0BAA0B;EAC1B,gCAAgC;AAClC;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc,IAAI,gCAAgC;EAClD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc,IAAI,mBAAmB;AACvC;;;AAGA;EACE,wBAAwB,EAAE,6BAA6B;AACzD","sourcesContent":[".cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 20px;\n  margin-top: 30px;\n}\n\n.cardBox {\n  background-color: #1e293b;\n  border-radius: 16px;\n  padding: 20px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n  transition: 0.3s ease-in-out;\n}\n\n.cardBox:hover {\n  transform: scale(1.03);\n}\n\n.cardtopic {\n  text-align: center;\n  margin-bottom: 16px;\n}\n\n.cardtopic h3 {\n  color: #ffffff;\n  font-size: 18px;\n}\n\n.circle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: auto;\n}\n\n.cards .circle {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  margin-top: 15px;\n}\n.cards .circle h1 {\n  font-size: 15px;\n  font-weight: 500;\n  color: #ffffff;\n}\n.cards .title {\n  text-align: right;\n}\n.cards .circle p {\n  color: #ffffff;\n  margin-top: 10px;\n  font-size: 17px;\n}\n.light .circle h1,\n.light .circle p {\n  color: #ffffff;\n}\n\n.Phasetitle {\n  font-size: 15px;\n  font-weight: 500;\n  color: #ffffff;\n  text-align: center;\n  writing-mode: vertical-rl;\n  transform: rotate(180deg);\n}\n.card.grid {\n  color: white;\n}\ng.tick text {\n  fill: #ffffff !important; /* White tick labels */\n  font-size: 15px !important;\n  font-family: 'Arial', sans-serif;\n}\n.dark g.tick text {\n  fill: #ffffff !important;\n}\n\n.cardHeading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.cardHeading h3 {\n  color: #ffffff;   /* Phase 1 / Phase 2 / Phase 3 */\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.cardHeading .headingIcon {\n  color: #ffffff;   /* three-dot icon */\n}\n\n\n.light g.tick text {\n  fill: #111827 !important; /* dark gray for light mode */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
